/**
 * Fájlletöltés indítása.
 *
 * A böngésző maga tölti le a fájlt a megadott címről — nem a program tartja
 * a memóriában. Így a nagy kimutatások sem lassítják be a felületet, és a
 * fájl a szokásos „Letöltések" mappába kerül.
 */
export function letolt(ut: string): void {
  const a = document.createElement('a');
  a.href = ut;
  // A fájlnevet a szerver mondja meg a Content-Disposition fejlécben.
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** A napi bontás szűrői ugyanúgy mennek az exportba, ahogy a képernyőn állnak. */
export function bontasParameterek(beallitas: {
  q?: string;
  fizetesiMod?: string;
  cegcsoportra?: boolean;
  nemVasarlokIs?: boolean;
  rendezes?: string;
}): string {
  const p = new URLSearchParams();
  if (beallitas.q?.trim()) p.set('q', beallitas.q.trim());
  if (beallitas.fizetesiMod) p.set('fizetesi_mod', beallitas.fizetesiMod);
  if (beallitas.cegcsoportra) p.set('cegcsoportra', '1');
  if (beallitas.nemVasarlokIs === false) p.set('nem_vasarlok_is', '0');
  if (beallitas.rendezes) p.set('rendezes', beallitas.rendezes);
  const s = p.toString();
  return s ? `?${s}` : '';
}
